import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { t } from '@fairstone/ui/core/providers/Intl/locales/translate';
import { Box } from '@mui/material';
import useAuth from 'context/useAuth';

import Dropdown from 'components/dropdown/Dropdown';
import EditProfileWrapper from 'components/forms/profile/EditProfileWrapper';
import CustomModal from 'components/modals/CustomModal';
import OverlaySpinner from 'components/spinner/OverlaySpinner';
import { PrimaryButtonSto } from 'components/sto';
import { AppRoutes } from 'routes';
import { updateProfile } from 'services/AccountService';

const PreferredLanguagePage = () => {
    const { formatMessage, locale } = useIntl();
    const { setUserProfile, userProfile } = useAuth();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [language, setLanguage] = useState(userProfile.language);
    const history = useHistory();

    const languageOptions = [
        {
            name: formatMessage({ id: 'pages.profile.language.english' }),
            value: 'E',
        },
        {
            name: formatMessage({ id: 'pages.profile.language.french' }),
            value: 'F',
        },
    ];

    const [modal, setModal] = useState({
        visible: false,
    });

    const handleApiSuccess = () => {
        setModal({
            modalType: 'success',
            okText: 'general.ok',
            onOk: handleGoBackOnSuccess,
            title: 'pages.profile.language.success.text',
            visible: true,
        });
    };

    const handleApiError = () => {
        setModal({
            modalType: 'fail',
            okText: 'general.ok',
            onOk: handleGoBackOnError,
            title: 'pages.profile.edit.failed',
            visible: true,
        });
    };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            setIsSubmitting(true);
            const res = await updateProfile({ language: language });
            setUserProfile((prevState) => ({
                ...prevState,
                language: res.find((o) => o.fieldToUpdate === 'language').fieldData,
            }));
            handleApiSuccess();
        } catch (error) {
            handleApiError();
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleGoBackOnSuccess = () => {
        setModal({ visible: false });
        history.push(`/${locale}/${formatMessage({ id: 'tab.label.profile' }).toLowerCase()}`);
    };

    const handleGoBackOnError = () => {
        setModal({ visible: false });
    };

    if (isSubmitting)
        return (
            <OverlaySpinner>
                <p>{t('spinner.submitting.information')}</p>
                <p>{t('spinner.message.2')}</p>
            </OverlaySpinner>
        );

    return (
        <EditProfileWrapper goBack={AppRoutes.profile} title="pages.profile.language.edit.heading">
            <Box className="profile-language-container">
                <form className="profile-language-content" onSubmit={handleSubmit}>
                    <label className="text-item-label" htmlFor="languages">
                        <FormattedMessage id="pages.profile.language.select" />
                    </label>
                    <Dropdown
                        id="languages"
                        name="languages"
                        onChange={(e) => setLanguage(e.target.value)}
                        options={languageOptions}
                        value={language}
                    />
                    <div className="buttons-container">
                        <PrimaryButtonSto
                            aria-disabled={language === userProfile.language}
                            disabled={language === userProfile.language}
                            labelKey="general.save"
                            type="submit"
                        />
                    </div>
                </form>
                <CustomModal
                    modalType={modal.modalType}
                    okText={modal.okText}
                    onOk={modal.onOk}
                    visible={modal.visible}
                >
                    <p>
                        <FormattedMessage id={modal.title} />
                    </p>
                </CustomModal>
            </Box>
        </EditProfileWrapper>
    );
};

export default PreferredLanguagePage;
